import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MultiFactorService } from '@app/shared/services/settings-multi-factor-service';
import { Login, Logout, Verify2FA } from '@app/shared/store/auth/auth.actions';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { AuthState } from '@shared/store/auth/auth.state';
import {TranslationService} from '@shared/services/translation.service';
import { switchMap } from 'rxjs/internal/operators/switchMap';

@Component({
    selector: 'saf-two-factor-verification',
    templateUrl: './two-factor-verification.component.html',
    styleUrls: ['./two-factor-verification.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TwoFactorVerificationComponent implements OnInit {
  otp: string = '';
  loading = false;
  error: string | null = null;
  isCooldown: boolean = false;
  countdown: number = 60;
  private countdownInterval: any = null;

  constructor(
    private router: Router,
    private twoFAService: MultiFactorService,
    private store: Store,
    private matSnackBar:MatSnackBar,
    private translationService:TranslationService
  ) {}
  ngOnInit(): void {

  }

  verify(): void {
    this.error = null;
    this.loading = true;

    const temp2FAToken = localStorage.getItem('temp2FAToken');
   // console.log(temp2FAToken,'set correctly');
    if (!temp2FAToken) {
      this.error = this.translationService.translate('missingTemp');
      this.loading = false;
      return;
    }

    this.store.dispatch(new Verify2FA({ temp2FAToken, otp: this.otp })).subscribe({
      next: () => {
        localStorage.removeItem('requires2FA');
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.message ||this.translationService.translate('Something went wrong during verification.');
        this.delayRetry();
        this.loading = false;
      }
    });
  }

  sendCodeToEmail(): void {
    this.loading = true;
    this.error = null;

    const temp2FAToken = localStorage.getItem('temp2FAToken');

    if (!temp2FAToken) {
      this.error = this.translationService.translate('Temporary 2FA token not found.');
      this.loading = false;
      return;
    }

    this.twoFAService.resetCode(temp2FAToken).pipe(
      switchMap(() => this.twoFAService.sendCode(temp2FAToken))
    ).subscribe({
      next: () => {
        this.matSnackBar.open(this.translationService.translate('Code Sent Succesfully'));
        this.startCooldown();
        this.loading = false;
      },
      error: err => {
        this.error = err?.error?.error || 'Unexpected error while sending email.';
        this.matSnackBar.open(this.translationService.translate('Error Occured while sending the code'));
        this.loading = false;
      }
    });
  }



  cancel(): void {
    this.store.dispatch(new Navigate(['/login']));
  }

  private delayRetry(): void {
    this.loading = true;
    setTimeout(() => (this.loading = false), 5000);
  }


  startCooldown(): void {
    this.isCooldown = true;
    this.countdown = 60;

    this.countdownInterval = setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        this.isCooldown = false;
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}



